import {
    Route,
    BrowserRouter as Router,
    Routes
} from "react-router-dom";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import numberingSystems from "cldr-core/supplemental/numberingSystems.json";
import weekData from "cldr-core/supplemental/weekData.json";
import timeData from "cldr-core/supplemental/timeData.json";
import auNumbers from "cldr-numbers-full/main/en-AU/numbers.json";
import auCurrency from "cldr-numbers-full/main/en-AU/currencies.json";
import auCaGregorian from "cldr-dates-full/main/en-AU/ca-gregorian.json";
import auDateFields from "cldr-dates-full/main/en-AU/dateFields.json";
import appRoutes, { type AppRoute } from "./routes/appRoutes";
import { IntlProvider, load } from "@progress/kendo-react-intl";

const renderRoutes = (routes: AppRoute[]) => {
    return routes.map(({ path, element, children, index }, i) => {
        if (index) {
            return <Route key={i} path={path} element={element} index />;
        } else {
            return (
                <Route key={i} path={path} element={element}>
                    {children && renderRoutes(children)}
                </Route>
            );
        }
    });
};

load(
    likelySubtags,
    currencyData,
    numberingSystems,
    weekData,
    timeData,
    auNumbers,
    auCurrency,
    auCaGregorian,
    auDateFields
);

function App() {
    return (
        <IntlProvider locale="en-AU">
            <Router>
                <Routes>
                    {renderRoutes(appRoutes)}
                </Routes>
            </Router>
        </IntlProvider>
    );
}

export default App;
